import HighchartsVue from 'highcharts-vue';
import Highcharts from "highcharts";
import sunburstInit from 'highcharts/modules/sunburst';
import ganttInit from 'highcharts/modules/gantt';
import Vue from "vue";

Highcharts.setOptions({
    lang: {
        loading: 'Cargando...',
        months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        exportButtonTitle: "Exportar",
        printButtonTitle: "Importar",
        rangeSelectorFrom: "Desde",
        rangeSelectorTo: "Hasta",
        rangeSelectorZoom: "Período",
        downloadPNG: 'Descargar imagen PNG',
        downloadJPEG: 'Descargar imagen JPEG',
        downloadPDF: 'Descargar imagen PDF',
        downloadSVG: 'Descargar imagen SVG',
        printChart: 'Imprimir',
        resetZoom: 'Reiniciar zoom',
        resetZoomTitle: 'Reiniciar zoom',
        decimalPoint: ',',
        thousandsSep: '.',
    }
});
Highcharts.theme = {
    chart: {
        backgroundColor: ''
    }
};
Highcharts.setOptions(Highcharts.theme);
sunburstInit(Highcharts);
ganttInit(Highcharts);
Vue.use(HighchartsVue);


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/highcharts.js